export default __webpack_public_path__ + "936e70cf4362d570cf94f0571e000dcc.png";